import { EPostFormFieldName, IBlogPostFormFields } from '../../types/postForm';
import { createInitialState, createPostFormReducer } from './createPostFormReducer';
import { TPostFormActions } from './postFormActions';

export const blogPostInitialState = createInitialState<IBlogPostFormFields>({
  [EPostFormFieldName.Title]: {
    errorMessage: '',
    required: false,
    value: '',
  },
});

export const blogPostFormReducer = createPostFormReducer<IBlogPostFormFields, TPostFormActions>(blogPostInitialState);
